import { Typography } from "antd";
import StatusPill from "../../components/UI/StatusPill";
import { textColor, pillColor, tooltipTitle } from "./VAStatusMapping";
const { Paragraph } = Typography;

export const getCellRenderer = (
  text: string | null | undefined,
  header: string,
  ellipsis: boolean,
  columnsWithEllipsis: Set<string>,
): React.ReactNode => {
  if (text === null || text === undefined) {
    return "-";
  }
  if (columnsWithEllipsis.has(header)) {
    return (
      <Paragraph
        ellipsis={ellipsis ? { rows: 3, tooltip: text } : false}
        style={{ margin: 0 }}
      >
        {text}
      </Paragraph>
    );
  }
  return (
    <StatusPill
      text={text}
      textColor={textColor}
      pillColor={pillColor}
      tooltipTitle={tooltipTitle}
    />
  );
};
